<template>
  <div class="quiz-result">
    <h3 class="results__title">{{ $t('quiz_result') }}</h3>
    <p class="mb-5 results__header-description">
      {{ $t('quiz_result_header') }}
    </p>
    <p>
      <kreatywna-druzynowa v-if="quizWinnerIndex === 1">
      </kreatywna-druzynowa>

      <niezrownana-zwyciezczyni v-if="quizWinnerIndex === 2">
      </niezrownana-zwyciezczyni>

      <kreatorka-rozwiazan v-if="quizWinnerIndex === 3">
      </kreatorka-rozwiazan>

      <kanapowa-menadzerka v-if="quizWinnerIndex === 4">
      </kanapowa-menadzerka>

      <realizujaca-marzenia v-if="quizWinnerIndex === 5">
      </realizujaca-marzenia>
    </p>
    <p v-if="quiz.displaySendResultsToEmailSectionAtEnd"
       class="social-section">
      <span class="separator mb-4"></span>
      <span class="email-info mb-3 d-block">
        Podaj swój adres e-mail, żeby przesłać na skrzynkę wyniki Quizu.
      </span>
      <send-email :targetTemplate="htmlTemplateFilenameBase">
      </send-email>
      <br/>

      <!-- eslint-disable -->
      <span v-if="quiz.displaySocialShareSectionAtEnd"
            class="social-info">
        <span class="separator mb-4"></span>
        Udostępnij stronę na:
        <span class="social-share-btn">
          <ShareNetwork network="facebook" :url="`${quiz.basicPortalUrl
            }/social/${htmlTemplateFilenameBase}.php`"
                        :title="`Liderki25 - Raport badawczy - Quiz: ${getScoringGroup(this.winnerIndex).groupName}`"
                        :popup="{width: 500, height: 400}">
            Facebook
          </ShareNetwork>
        </span>

        <span class="social-share-btn">
          <ShareNetwork network="twitter"
                        :url="`${quiz.basicPortalUrl
            }/social/${htmlTemplateFilenameBase}.php`"
                        :title="`Liderki25 - Raport badawczy - Quiz: ${getScoringGroup(this.winnerIndex).groupName}`"
                        :popup="{width: 500, height: 400}">
            X (Twitter)
          </ShareNetwork>
        </span>
        <!-- eslint-enable -->

        <div>
          Masz pytania związane z QUIZEM? Napisz do nas:
          <a href="mailto:info@ircenter.com" target="_blank">info@ircenter.com</a>
        </div>
      </span>
    </p>
  </div>
</template>

<script>
import SendEmail from '@/views/parts/SendEmail';
import KreatorkaRozwiazan from '@/views/results/KreatorkaRozwiazan.vue';
import KreatywnaDruzynowa from '@/views/results/KreatywnaDruzynowa.vue';
import KanapowaMenadzerka from '@/views/results/KanapowaMenadzerka.vue';
import NiezrownanaZwyciezczyni from '@/views/results/NiezrownanaZwyciezczyni.vue';
import RealizujacaMarzenia from '@/views/results/RealizujacaMarzenia.vue';

export default {
  name: 'Result',
  props: ['questions', 'scoring', 'testModeResolutionWasUsed', 'winnerIndex'],
  components: {
    SendEmail,
    KreatorkaRozwiazan,
    KreatywnaDruzynowa,
    KanapowaMenadzerka,
    NiezrownanaZwyciezczyni,
    RealizujacaMarzenia,
  },
  data() {
    return {
      correctCount: 0,
      score: 100.0,
      scoreByAnswerCount: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
        4: 0,
      },
      calculatedScoring: [
        {
          groupIndex: 1,
          groupName: 'Kreatywna Drużynowa',
          total: 0,
          htmlTemplateFilenameBase: '',
        },
        {
          groupIndex: 2,
          groupName: 'Niezrównana Zwyciężczyni',
          total: 0,
          htmlTemplateFilenameBase: '',
        },
        {
          groupIndex: 3,
          groupName: 'Kreatorka Rozwiązań',
          total: 0,
          htmlTemplateFilenameBase: '',
        },
        {
          groupIndex: 4,
          groupName: 'Kanapowa Menadżerka',
          total: 0,
          htmlTemplateFilenameBase: '',
        },
        {
          groupIndex: 5,
          groupName: 'Realizująca Marzenia',
          total: 0,
          htmlTemplateFilenameBase: '',
        },
      ],
      quiz: window.Quiz,
    };
  },
  created() {
    // if (!this.calculatedScoring) {
    //   this.calculatedScoring = [];
    // }
    // this.calculateResult();
    // this.calculateScoringResults();
    this.calculateScoringResultsByAnswerQuantity();
  },
  computed: {
    quizWinnerIndex() {
      console.log('quizWinnerIndex()', this.winnerIndex);
      const winner = this.scoring[this.winnerIndex - 1]
        ? this.scoring[this.winnerIndex - 1].groupIndex
        : 0;
      console.log('winnerIndex', winner);

      return winner;
    },

    htmlTemplateFilenameBase() {
      const group = this.scoring.find(group => group.groupIndex === this.winnerIndex);

      // console.log('scoringGroup', group.groupIndex, group.groupName, group);
      return group ? group.htmlTemplateFilenameBase : '';
    },
  },
  methods: {
    calculateResult() {
      this.questions.forEach((item, index) => {
        if (item.isCorrect) {
          this.correctCount += 1;
        }
      });

      this.score = ((this.correctCount / this.questions.length) * 100).toFixed(2);
    },
    calculateScoringResults() {
      console.log('calculateScoringResults()');
      console.log(this.questions);
      if (!this.testModeResolutionWasUsed) {
        this.questions.forEach((item, index) => {
          this.scoring.forEach((group, i) => {
            const g = this.getScoringGroup(group.groupIndex);
            if (g.total === 0) {
              g.total = group.scoringConstant;
              g.groupIndex = group.groupIndex;
              g.groupName = group.groupName;
              g.htmlTemplateFilenameBase = group.htmlTemplateFilenameBase;
            }

            const optionScore = item.answers[item.answer].score;
            g.total += (optionScore * group.scoreWeights[index]);
          });
        });

        // find the biggest value
        let winnerValue = -99999;
        let winnerGroup;

        this.calculatedScoring.forEach((group) => {
          if (group.total > winnerValue) {
            winnerValue = group.total;
            this.$parent.winnerIndex = group.groupIndex;
            winnerGroup = group;
          }
        });

        const table = [];
        this.calculatedScoring.forEach((row) => {
          const groupRow = {
            groupIndex: row.groupIndex,
            groupName: row.groupName,
            total: row.total,
          };
          // console.log('groupRow', groupRow);
          table.push(groupRow);
        });

        // console.clear();
        console.log('WYNIKI QUIZU:');
        console.log(`Grupa: ${winnerGroup.groupIndex}: ${winnerGroup.groupName}`);
        console.log(`Wynik: ${winnerGroup.total}`);
        console.table(table);
      }
    },

    calculateScoringResultsByAnswerQuantity() {
      if (!this.testModeResolutionWasUsed) {
        console.log(this.questions);

        this.questions.forEach((item, index) => {
          this.scoreByAnswerCount[item.answer[0]] = this.scoreByAnswerCount[item.answer[0]]
            + item.answers[item.answer[0]].score;
        });

        const maxValue = Math.max(...Object.values(this.scoreByAnswerCount));

        const keysWithMaxValue = Object.keys(this.scoreByAnswerCount).filter(
          key => this.scoreByAnswerCount[key] === maxValue,
        );

        const hasMultipleMaxValues = keysWithMaxValue.length > 1;

        // eslint-disable-next-line prefer-destructuring
        this.$parent.winnerIndex = parseInt(keysWithMaxValue[0], 10) + 1;
        const table = [];

        Object.values(this.scoreByAnswerCount).forEach((value, index) => {
          const groupRow = {
            groupIndex: index + 1,
            total: value,
          };
          table.push(groupRow);
        });

        console.clear();
        console.log('WYNIKI QUIZU:');
        // console.log(`Grupa: ${winnerGroup.groupIndex}: ${winnerGroup.groupName}`);
        // console.log(`Wynik: ${winnerGroup.total}`);
        console.log('Max wynik:', maxValue); // Output: Max value is: 7
        console.log('Grupy z max wynikiem:', keysWithMaxValue); // Output: Keys with max value: ["1", "3"]
        console.log('Czy jest remis?', hasMultipleMaxValues); // Output: Are there duplicates? true
        console.table(table);

        // this.logResults();
      }
    },

    getScoringGroup(index) {
      return this.calculatedScoring.find(group => group.groupIndex === index);
    },
  },
};
</script>

<style>
.quiz-result .content {
  display: flex;
}
.results__title {
  text-align: center;
  background-size: auto 60%;
}
.results__header-description {
  text-align: center;
}

/* result images col */
.quiz-result .images-col {
  padding: 0 3em 0 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
.quiz-result .percentage-img {
  width: 60%;
  background: #FFFFFF;
  padding: 1em;
  border-radius: 900px;
  position: relative;
  margin-top: -25%;
  align-self: flex-end;
}

/* description */
.quiz-result .description {
  flex-grow: 1;
}
.quiz-result .title {
  padding-bottom: .2em;
  font-family: "Figtree", sans-serif;
  font-size: 3em;
  font-weight: 900;
  line-height: 1.1;
  color: var(--color-project-text);

  margin-bottom: .5em;
}
.quiz-result .title .text {
  position: relative;
  filter: drop-shadow(0px 0px 1px white) drop-shadow(0px 0px 1px white);
}

/* percentage */
.quiz-result .images-col {
  padding-left: 1em;
  margin-bottom: 1em;
  align-items: center;
}
.quiz-result .images-col .thumbnail {
  display: flex;
  justify-content: center;
}
.quiz-result .images-col .percentage {
  display: flex;
  flex-direction: column;
}
/*.quiz-result .percentage-img {*/
/*  height: 70vh;*/
/*  max-height: 700px;*/
/*}*/

.quiz-result .percentage__value {
  display: inline-block;
  position: absolute;
  right: 62%;
  margin-top: 5%;

  font-size: 1.8em;
  line-height: 1;
  text-align: left;
  font-weight: 900;
  display: inline-block;
  position: absolute;
}

.quiz-answer {
  padding: 3px 5px;
  margin: 3px 0;
  cursor: pointer;
}

.correct-answer {
  border: 1px solid #36bf42;
}

.wrong-answer {
  border: 1px solid #ef251c;
}


/* EMAIL */
.email-info,
.social-info {
  color: black;
}
.separator {
  height: 1px;
  background: black;
  width: 300px;
  max-width: 100%;
  display: block;
}
.social-info {
  display: block;
}
.social-share-btn {
  margin: 0 0.5em;
}

@media screen and (min-width: 1400px) {
  .images-col {
    width: 33%;
  }
}
@media screen and (max-width: 812px) {
  .quiz-result .title::before {
    height: 77px;
  }
}
@media screen and (max-width: 600px) {
  .quiz-result .title::before {
    height: 50px;
  }
  .quiz-result .title {
    font-size: 2em;
  }
}
</style>
